import React from 'react';

interface SuccessIconProps {
  fill?: string;
  width?: string | number;
  height?: string | number;
}

export const SuccessIcon: React.FC<SuccessIconProps> = ({ fill = '#1d7351', width = 16, height = 16 }) => (
  <svg width={width} height={height} viewBox="0 0 26 26" fill="none">
    <circle cx="12" cy="12" r="12" fill="#40FFB1" />
    <path
      d="M17.043375,8.606625 C17.455725,8.156925 18.111975,8.813175 17.699625,9.262875 C15.4123125,11.8498125 13.105875,14.4 10.8001875,16.96875 C10.687395,17.0998538 10.5753375,17.21265 10.4625375,17.34375 C10.29408,17.53125 9.9747375,17.5122075 9.8062875,17.34375 C8.6439375,16.2378 7.4816625,15.112875 6.3184125,14.0060625 C5.8870125,13.5937125 6.5432625,12.9184125 6.9746625,13.3498125 C8.0249625,14.3437125 9.0562875,15.3376875 10.105725,16.3498125 C12.4311,13.762875 14.7375375,11.1935625 17.043225,8.606625 L17.043375,8.606625 Z"
      fill={fill}
    />
  </svg>
);
